import React from 'react';
import HeroImageManager from '../../components/admin/HeroImageManager';

const Hero: React.FC = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="py-6">
        <h1 className="text-2xl font-semibold text-gray-900">Hero Images</h1>
        <div className="mt-6">
          <HeroImageManager />
        </div>
      </div>
    </div>
  );
};

export default Hero; 